var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mx-1 d-print-none",attrs:{"color":"primary","icon":""},on:{"click":_vm.printSubmission}},[_c('v-icon',[_vm._v("print")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }